$(".m-links .m-nav").hover(function () {  
  $(".m-links .m-nav").attr("data-menu-active", "false");
  var dataSrcValue = $(this).data("id");
  console.log('dataSrcValue');
  $(this).attr("data-menu-active", "true");
  $(".m-sub-nav").hide();
  $("#" + dataSrcValue + "").css("display", "flex");
});

$(".second-level").click(function () {
  $(".custom-mobile-menu").hide();
});
$(".custom-mobile-menu .m-nav a").click(function () {
  $(".custom-mobile-menu .m-nav").attr("data-m-active", "false");
  var dataIdValue = $(this).data("id");
  var getText = $(this).text().trim();
  $(this).next().attr("data-m-active", "true");
});
$(".custom-mobile-menu .m-nav a.m-level-2").click(function () {
  var getText = $(this).text().trim();
  $(".third-level span").text(getText);
});
$(".custom-mobile-menu .m-nav a.m-level-3").click(function () {
  var getText = $(this).text().trim();
  $(".four-level span").text(getText);
});

$(".back-text-with-icon").click(function () {
  $(".custom-mobile-menu .m-nav").attr("data-m-active", "false");
  $(this).parent().parent().attr("data-m-active", "true");
});
$(".main-mob-category").click(function () {
  var dataIdValue = $(this).data("id");
  console.log(dataIdValue);
  var getText = $(this).text().trim();
  $(".custom-mobile-menu").show();
  $("#" + dataIdValue + "").attr("data-m-active", "true");
  $(".second-level span").text(getText);
});
